import React from 'react'
import { Grid, Button, Box, Typography } from '@mui/material'
import { map, isEmpty, slice, find, compact } from '@/utils/lodash'
import { PropertyCardPublic } from '@/housefolios-components/Property/PropertyCard'
import { PropertyCardSkeleton } from '@/housefolios-components/Property/PropertyCardSkeleton'
import {
  marketingSectionSx,
  marketingHeadingSx,
  marketingSubheadingSx,
} from '@/housefolios-components/PublicPages/publicPageSx'

/**
 * Property section component for public home page
 * Displays featured properties or a subset of available properties
 */
const PropertySection = ({
  properties,
  featuredProperties,
  marketplace,
  subdomainParam,
  title = 'Properties for Sale',
  subtitle = 'We bring the deals to you!',
  showTitle = false,
  loading = false,
}) => {
  let displayProperties =
    marketplace &&
    compact(
      map(featuredProperties, (id) =>
        find(properties, (property) => property._id === id),
      ),
    )

  if (isEmpty(displayProperties)) {
    displayProperties = slice(properties, 0, 6)
  }

  return (
    <Box
      component="section"
      id="forsale"
      style={{ minHeight: 500 }}
      sx={[marketingSectionSx, { backgroundColor: '#f4f5fd', pt: '50px' }]}
    >
      <Grid container sx={{ width: '100%' }}>
        {showTitle && (
          <Grid size={12} sx={{ width: '100%', textAlign: 'center' }}>
            <Typography variant="h2" component="h2" sx={marketingHeadingSx}>
              {title}
            </Typography>
            <Typography variant="h3" component="h3" sx={[marketingSubheadingSx, { color: '#a6a6b9' }]}>
              {subtitle}
            </Typography>
          </Grid>
        )}

        <Grid size={12} sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
          <Grid container spacing={4} sx={{ width: '100%', p: '20px' }}>
          {loading ? (
            <PropertyCardSkeleton count={6} isPublic />
          ) : (
            map(displayProperties, (property) => (
              <PropertyCardPublic
                key={property._id}
                property={property}
                marketplace={marketplace || 'null'}
                shared
                subdomainParam={subdomainParam}
              />
            ))
          )}
          </Grid>
        </Grid>

        {!loading && (
          <Grid
            size={12}
            style={{ textAlign: 'center' }}
            sx={{ width: '100%' }}
          >
            <br />
            {properties?.length < 1 && (
              <Button
                variant="contained"
                color="primary"
                component="a"
                href={`/properties${subdomainParam}`}
                style={{
                  color: 'white',
                  fontWeight: 700,
                  padding: '0.5rem 1rem',
                  fontSize: '1.25rem',
                  lineHeight: '1.5',
                }}
              >
                Click to View Properties
              </Button>
            )}
            {properties?.length >= 1 && (
              <Button
                variant="contained"
                color="primary"
                component="a"
                href={`/properties${subdomainParam}`}
                style={{
                  color: 'white',
                  fontWeight: 700,
                  padding: '0.5rem 1rem',
                  fontSize: '1.25rem',
                  lineHeight: '1.5',
                }}
              >
                View All Properties For Sale
              </Button>
            )}
            {marketplace && marketplace.preApprovedURL && (
              <Button
                variant="contained"
                color="primary"
                component="a"
                href={marketplace.preApprovedURL}
                target="_blank"
                style={{
                  color: 'white',
                  fontWeight: 700,
                  padding: '0.5rem 1rem',
                  fontSize: '1.25rem',
                  lineHeight: '1.5',
                  marginLeft: 5,
                }}
              >
                Get Pre Approved
              </Button>
            )}
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

export default PropertySection
